import { BaseModel } from "@/models/base.model"
import { ModelFactory } from "@/factories/model-factory"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model"
import type { IWorkspaceAudienceGroupMember } from "@/workspace/interfaces/api/workspace-audience-group-member.interface"

export class WorkspaceAudienceGroupMember
  extends BaseModel
  implements IWorkspaceAudienceGroupMember
{
  public static className = "WorkspaceAudienceGroupMember"
  public static verboseName = "werkruimtegroepslid"
  public static override managedResolveFields = ["knownBusinessEntityContact"]

  declare id: string
  audienceGroup: string
  knownBusinessEntityContact: KnownBusinessEntityContact

  constructor(member: IWorkspaceAudienceGroupMember, managed = false) {
    super(member)
    this.audienceGroup = member.audienceGroup
    this.knownBusinessEntityContact = ModelFactory.childModel(
      KnownBusinessEntityContact,
      member.knownBusinessEntityContact,
      managed
    )
  }
}
